import * as React from 'react';
import * as style from './OtherDevelopersWrapper.css';
import { Responsive, UIHeading1, UIHeading2 } from '@cian/ui-kit';
import { VerticalSlider } from '../VerticalSlider';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IOtherDevelopersWrapperProps {
  onShow: () => void;
}

export const OtherDevelopersWrapper = ({ children, onShow }: React.PropsWithChildren<IOtherDevelopersWrapperProps>) => {
  return (
    <section id="other-developers" className={style['wrapper']} data-testid="OtherDevelopers">
      <ActionAfterViewObserver callback={onShow} triggerOnce>
        <>
          <Responsive desktop>
            <UIHeading1>Другие застройщики</UIHeading1>
          </Responsive>
          <Responsive phone tablet>
            <UIHeading2>Другие застройщики</UIHeading2>
          </Responsive>
        </>
      </ActionAfterViewObserver>
      <VerticalSlider arrowOffset={0}>{children}</VerticalSlider>
    </section>
  );
};
